require('./helpers/bundle-manifest').register(JSON.parse("{\"46bxV\":\"main.js\",\"asObT\":\"countup.13b1699d.js\",\"5v78p\":\"main.css\"}"));